export default {
  AGENT_ID: 'agent_id',
  GRADES: 'grades',
  GRADE_SUM: 'grade_sum',
  NAME: 'name',
  GOAL: 'goal',
};
